import { Flex, Box, Spacer, Heading } from "@chakra-ui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootStore } from "../../../redux/Store";
import GovernmentCard from "../Home/GovernmentCard";
import UISkeletons from "../Utils/UiSkeletons";

function Government() {
  const dataState = useSelector((state: RootStore) => state.data);
  const government = dataState.governmentsData?.governments;
  const uiState = useSelector((state: RootStore) => state.ui);
  const skeleton = Array.from({ length: 4 }).map((item, index) => (
    <UISkeletons key={index} />
  ));
  const govAvgRating = (gov: IgovernmentData): number => {
    let avgRating: number = 0;

    const govReview = gov.reviews;
    for (let i = 0; i < Number(govReview?.length); i++) {
      if (govReview != undefined) {
        avgRating += Number(govReview[i].rating);
      }
    }
    if (Number(govReview?.length)) {
      return avgRating / Number(govReview?.length);
    }
    return 0;
  };
  return (
    <>
      <div
        className="row"
        style={{
          margin: "auto",
          justifyContent: "space-evenly",
        }}
      >
        <Flex>
          <Box>
            <Heading as="h3" margin="7.5px" id="governmentHeading">
              All Government
            </Heading>
          </Box>
          <Spacer />
        </Flex>
        {!uiState.governmentLoading ? (
          <>
            {government?.map((gov) => (
              <GovernmentCard
                _id={String(gov._id)}
                image={String(gov.image)}
                status={String(gov.status)}
                country={String(gov?.majority?.country?.name)}
                description={String(gov.description)}
                manOnIncharge={String(gov.manOnIncharge)}
                reviewCount={gov.reviews?.length}
                rating={govAvgRating(gov)}
              />
            ))}
          </>
        ) : (
          skeleton
        )}
      </div>
    </>
  );
}

export default Government;
